import { defineMessages } from "react-intl";

import { useFormatMessage } from "../../Intl/Context";

export const useCheckboxesSchema = ({
  type,
  required,
  parent,
  singleOptionSelection,
  maximumSelectableOptions
}) => {
  const t = useFormatMessage();
  const requiredErrorMessage = singleOptionSelection
    ? t(intlMessages.singleOptionRequiredErrorMessage)
    : t(intlMessages.multiOptionsRequiredErrorMessage);
  const tooLongMessage =
    maximumSelectableOptions &&
    t(intlMessages.tooLongMessage, {
      count: maximumSelectableOptions
    });

  return {
    type,
    parent,
    validations: {
      required: required && { type, errorMessage: requiredErrorMessage },
      otherValueRequired: true,
      length: !singleOptionSelection &&
        maximumSelectableOptions && { maximum: maximumSelectableOptions, tooLongMessage }
    }
  };
};

const intlMessages = defineMessages({
  singleOptionRequiredErrorMessage: {
    id: "answers.checkBoxes.error.singleOptionRequiredErrorMessage",
    defaultMessage: "Merci de sélectionner une option."
  },
  multiOptionsRequiredErrorMessage: {
    id: "answers.checkBoxes.error.multiOptionsRequiredErrorMessage",
    defaultMessage: "Merci de sélectionner au moins une option."
  },
  tooLongMessage: {
    id: "answers.checkBoxes.error.tooLongMessage",
    defaultMessage: "Merci de sélectionner au maximum {count} options."
  }
});
